import {BillingAccountType} from "@/common/dto/TransAccount";

export const AccountTypes: BillingAccountType[] = [
  "BANK",
  "CARD",
  "INC",
  "EXP",
  "SAVE",
  "CASH",
  "EXT",
  "INVESTMENT",
];

export const accountTypeNames: Record<BillingAccountType, string> = {
  BANK: "은행",
  CARD: "신용카드",
  EXT: "개인거래",
  INC: "수입",
  EXP: "지출",
  CASH: "현금",
  SAVE: "저축",
  INVESTMENT: "투자",
};

export const MAX_TRANS_LIST_ITEM_COUNT = 300;